/* eslint-disable import/prefer-default-export */

import { environment, channelNames } from './config';
import { getStyle } from './utils/http';
import SlugShare from '.';
export async function initRender(share: SlugShare) {
  const { config, closeMenu, shareTo } = share;
  const event = config?.options?.eventListener
    ? config.options.eventListener
    : 'click';
  const testEnv = typeof module !== 'undefined' && module.exports; // 在测试环境中
  if (!testEnv) {
    await getStyle('https://tiem-cdn.qq.com/slugteam/slug-share/styles/sdkshare.1.0.css');
  }

  if (environment === 'outgame' && !testEnv) {
    const fragment = document.createElement('div');
    fragment.innerHTML = `<div class="ig-sharemenu ig-sharemenu-hidden">
            <div class="ig-sharemenu-layer"></div>
            <div style="position: absolute;height: 100%;width: 100%; top: 0; right: 0;background: no-repeat right top url(${config.getOutgameTipsIcon()})"></div>
        </div>`;
    document.body.appendChild(fragment);
    const layerDom = document.querySelector('.ig-sharemenu');
    layerDom?.addEventListener(event, (e) => {
      e.preventDefault();
      typeof closeMenu === 'function' && closeMenu.apply(share);
    });
    return;
  }
  // 去除原来的蒙层
  document.getElementById('ig-sharemenu')?.remove();
  const fragment = document.createElement('div');
  const panel = document.createElement('div');
  const layer = document.createElement('div');
  const msdklalyer = document.createElement('div');
  const channelbd = document.createElement('div');
  const channelList = document.createElement('ul');
  const channels = config.getChannels();
  channels.forEach((channel) => {
    const channelN = document.createElement('li');
    channelN.innerHTML = `<a href="javascript:; "><span class="ig-sharemenu-icon ig-sharemenu-${channel}"></span><p>${channelNames[channel]}</p></a>`;
    channelList.appendChild(channelN);
  });

  // 创建游戏内视图
  const closebtn = document.createElement('a');
  closebtn.setAttribute('title', '关闭');
  closebtn.className = 'ig-sharemenu-close';
  closebtn.innerText = '关闭';
  msdklalyer.className = 'msdkshare-layer';
  msdklalyer.innerHTML = `<div class="msdkshare-icon" style="position: absolute;height: 100%;width: 100%; top: 0; right: 0;background: no-repeat center url(${
    config?.options?.msdkicon ? config.options.msdkicon : ''
  });background-size: contain"></div>`;
  msdklalyer.setAttribute(
    'style',
    'display: none; position: absolute;height: 100%;width: 100%; top: 0; right: 0;background: white;',
  );

  channelbd.className = 'ig-sharemenu-bd';
  channelbd.appendChild(channelList);
  channelbd.appendChild(closebtn);
  layer.className = 'ig-sharemenu-layer';
  panel.className = 'ig-sharemenu ig-sharemenu-hidden';
  panel.appendChild(layer);
  panel.appendChild(channelbd);

  panel.appendChild(msdklalyer);
  fragment.appendChild(panel);
  fragment.setAttribute('id', 'ig-sharemenu');
  document.body.appendChild(fragment);

  // 蒙层
  const sharePanel = document.querySelector('.ig-sharemenu');
  const layerDom = sharePanel?.querySelector('.ig-sharemenu-layer');
  const closeDom = sharePanel?.querySelector('.ig-sharemenu-close');

  layerDom?.addEventListener(event, (e) => {
    e.preventDefault();
    typeof closeMenu === 'function' && closeMenu.apply(share);
  });

  closeDom?.addEventListener(event, (e) => {
    e.preventDefault();
    typeof closeMenu === 'function' && closeMenu.apply(share);
  });

  channels.forEach((channel) => {
    sharePanel
      ?.querySelector(`.ig-sharemenu-${channel}`)
      ?.addEventListener(event, (e) => {
        e.preventDefault();
        typeof shareTo === 'function' && shareTo(channel);
      });
  });
}
